<template>
  <CRow>
    <CCol col="12">
      <CCard>
        <CCardHeader>
          <CRow>
            <CCol sm="7">
              <h4 id="traffic" class="card-title mb-0 ml-3">
                Member POS - List
              </h4>
            </CCol>
            <CCol sm="5" class="d-none d-md-block"></CCol>
          </CRow>
        </CCardHeader>
        <CCardBody>
          <CRow class="form-group">
            <CCol>
              <div>
                <CButton
                  @click="showHideFormCreate"
                  color="primary"
                  class="float-left ml-3 pt-2"
                >
                  <CIcon name="cil-user-follow" />
                  <span class="p-2">Member POS</span>
                </CButton>
                <CButton
                  @click="showHideFormUsernameCreate"
                  color="primary"
                  class="float-left ml-3 pt-2"
                >
                  <CIcon name="cil-user-follow" />
                  <span class="p-2">Username POS</span>
                </CButton>
              </div>
              <div class="form-create-bulk-pos" v-if="showFormCreate">
                <CCard>
                  <CCardHeader>
                    <CRow>
                      <CCol sm="10" class="">
                        <h5 id="traffic" class="card-title ml-3 mb-0">
                          Upload Berkas
                        </h5>
                      </CCol>
                      <CCol
                        sm="2"
                        class="d-flex justify-content-end"
                        @click="hideFormCreate"
                        ><CIcon type="button" name="cil-x-circle"
                      /></CCol>
                    </CRow>
                  </CCardHeader>
                  <CCardBody class="border-bottom-0">
                    <CRow>
                      <CCol sm="12" class="ml-3">
                        <h5 id="traffic" class="card-title mb-3">
                          Bulk Create Member POS
                        </h5>
                      </CCol>
                      <CCol sm="12" class="ml-3">
                        <div class="label-input-file pt-1">
                          <label for="label-file-wording" class="btnd"
                            >Pilih Berkas :
                          </label>
                          <label class="file-name-inputs">
                            {{ fileName }}</label
                          >
                        </div>
                      </CCol>
                      <CCol sm="12">
                        <input
                          @change="setFile($event, 'member')"
                          type="file"
                          id="uploads"
                          class="file"
                        />
                      </CCol>
                    </CRow>
                  </CCardBody>
                  <CRow class="form-group">
                    <CCol :col="6">
                      <CButton
                        @click="exportTemplate('template_member_pos')"
                        color="primary"
                        class="float-left btn-member-upload mt-2 mb-2"
                      >
                        Download Template
                      </CButton>
                    </CCol>
                    <CCol :col="6" class="">
                      <CButton
                        @click="bulkInsert('member')"
                        color="primary"
                        class="float-right btn-username-upload mt-2 mb-2"
                      >
                        Upload
                      </CButton>
                    </CCol>
                  </CRow>
                </CCard>
              </div>
              <div class="form-create-bulk-pos" v-if="showFormUsernameCreate">
                <CCard>
                  <CCardHeader>
                    <CRow>
                      <CCol sm="10" class="">
                        <h5 id="traffic" class="card-title ml-3 mb-0">
                          Upload Berkas
                        </h5>
                      </CCol>
                      <CCol
                        sm="2"
                        class="d-flex justify-content-end"
                        @click="hideFormUsernameCreate"
                        ><CIcon type="button" name="cil-x-circle"
                      /></CCol>
                    </CRow>
                  </CCardHeader>
                  <CCardBody class="border-bottom-0">
                    <CRow>
                      <CCol sm="12" class="ml-3">
                        <h5 id="traffic" class="card-title mb-3">
                          Bulk Create Username POS
                        </h5>
                      </CCol>
                      <CCol sm="12" class="ml-3">
                        <div class="label-input-file pt-1">
                          <label for="label-file-wording" class="btnd"
                            >Pilih Berkas :
                          </label>
                          <label class="file-name-inputs">
                            {{ fileUsername }}</label
                          >
                        </div>
                      </CCol>
                      <CCol sm="12">
                        <input
                          @change="setFile($event, 'username')"
                          type="file"
                          id="uploads"
                          class="file"
                        />
                      </CCol>
                    </CRow>
                  </CCardBody>
                  <CRow class="form-group">
                    <CCol :col="6">
                      <CButton
                        @click="exportTemplate('template_username_pos')"
                        color="primary"
                        class="float-left btn-member-upload mt-2 mb-2"
                      >
                        Download Template
                      </CButton>
                    </CCol>
                    <CCol :col="6" class="">
                      <CButton
                        @click="bulkInsert('username')"
                        color="primary"
                        class="float-right btn-username-upload mt-2 mb-2"
                      >
                        Upload
                      </CButton>
                    </CCol>
                  </CRow>
                </CCard>
              </div>
            </CCol>
            <CRow class="float-right">
              <div class="search-list">
                <CCol sm="12">
                  <CInput
                    class="float-left mb-0 mr-2"
                    placeholder="Search By POS Code"
                    v-model="query"
                  >
                    <template #prepend-content>
                      <CIcon name="cil-magnifying-glass" />
                    </template>
                  </CInput>
                </CCol>
              </div>
            </CRow>
          </CRow>
        </CCardBody>
        <CCardFooter>
          <CDataTable
            hover
            striped
            :items="memberPOSList"
            :fields="fields"
            :items-per-page="10"
            clickable-rows
            :active-page="1"
            :pagination="false"
            @page-change="pageChange"
          >
            <template #created_at="data">
              <td>
                <div class="button-table">
                  <CButton
                    color="primary"
                    class="mb-0"
                    @click="toDetailPage(data.item.id)"
                    >Detail</CButton
                  >
                  <CButton
                    color="warning"
                    class="mb-0 ml-1"
                    @click="toEditPage(data.item.id)"
                    >Edit</CButton
                  >
                </div>
              </td>
            </template>
          </CDataTable>
          <div class="pagination-nav">
            <div
              class="pagination-btn-refresh"
              @click="paginateData('REFRESH')"
            >
              Refresh
            </div>
            <div class="pagination-btn-back" @click="paginateData('BACK')">
              back
            </div>
            <div class="pagination-page-title">{{ page }}</div>
            <div class="pagination-btn-next" @click="paginateData('NEXT')">
              next
            </div>
          </div>
        </CCardFooter>
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
// import usersData from './UsersData'
import axios from "axios";
import jwt from "jsonwebtoken";
import Swal from "sweetalert2";
import XLSX from "xlsx";
export default {
  name: "MemberPOS",
  data() {
    return {
      memberPOSList: [],
      fields: [
        { key: "email", label: "Email", _style: "width:25%" },
        { key: "pos_code", label: "POS Code", _style: "width:25%" },
        { key: "pos_name", label: "POS Name", _style: "width:25%" },
        { key: "created_at", label: "Action", _style: "width:15%" },
      ],
      fileName: "",
      fileData: "",
      fileUsername: "",
      fileDataUsername: "",
      page: 1,
      query: "",
      templateMemberPOS: [
        {
          email: "xample@email.com",
          pos_name: "xample name",
          pos_code: "xample pos code",
        },
      ],
      templateUsernamePOS: [
        { pos_code: "xample pos code", username: "xample username" },
      ],
      showFormCreate: false,
      showFormUsernameCreate: false,
      domain: process.env.VUE_APP_DOMAIN_URL,
      token: "Bearer " + localStorage.getItem("token"),
    };
  },
  watch: {
    query() {
      if (this.query === "") {
        this.paginateData('');
      }else{
        this.paginateData('');
      }
    },
  },
  beforeMount() {
    this.authentication();
    this.paginateData();
  },
  methods: {
    pageChange(val) {
      this.$router.push({ query: { page: val } });
    },
    authentication() {
      const data = jwt.decode(localStorage.getItem("token"));
      if (
        data.account_group === "NPOS" ||
        data.account_group === "ADMIN" ||
        data.account_group === "ADMINISTRATOR"
      ) {
        return null;
      } else {
        this.$router.push({ path: `/` });
      }
    },

    showHideFormCreate() {
      this.fileUsername = "";
      this.fileName = "";
      this.fileData = "";
      this.fileDataUsername = "";
      this.showFormCreate = !this.showFormCreate;
    },

    hideFormCreate() {
      this.fileUsername = "";
      this.fileName = "";
      this.fileData = "";
      this.fileDataUsername = "";
      this.showFormCreate = false;
    },
    showHideFormUsernameCreate() {
      this.fileUsername = "";
      this.fileName = "";
      this.fileData = "";
      this.fileDataUsername = "";
      this.showFormUsernameCreate = !this.showFormUsernameCreate;
    },

    hideFormUsernameCreate() {
      this.fileUsername = "";
      this.fileName = "";
      this.fileData = "";
      this.fileDataUsername = "";
      this.showFormUsernameCreate = false;
    },

    rowClicked(item) {
      this.$router.push({ path: `/management/member-pos/${item}` });
    },

    setFile(file, type) {
      var fullPath = file.target.value;
      if (fullPath) {
        var startIndex =
          fullPath.indexOf("\\") >= 0
            ? fullPath.lastIndexOf("\\")
            : fullPath.lastIndexOf("/");
        var filename = fullPath.substring(startIndex);
        if (filename.indexOf("\\") === 0 || filename.indexOf("/") === 0) {
          filename = filename.substring(1);
        }
        const extension = filename.split(".");
        if (extension[extension.length - 1] !== "xlsx") {
          this.responseMessage("error", "Format file harus excel");
          if (type === "member") {
            this.fileName = "";
            this.fileData = "";
          } else if (type === "username") {
            this.fileUsername = "";
            this.fileDataUsername = "";
          }
        } else {
          if (type === "member") {
            this.fileName = filename;
            this.fileData = file.target.files[0];
          } else if (type === "username") {
            this.fileUsername = filename;
            this.fileDataUsername = file.target.files[0];
          }
        }
      }
    },
    responseMessage(icon, message) {
      const Toast = Swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 2000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", Swal.stopTimer);
          toast.addEventListener("mouseleave", Swal.resumeTimer);
        },
      });

      Toast.fire({
        icon: icon,
        title: message,
      });
    },
    paginateData(payload) {
      if (payload === "NEXT") {
        this.page = this.page + 1;
      } else if (payload === "BACK") {
        if (this.page > 1) {
          this.page = this.page - 1;
          window.scrollTo(0, 0);
        }
      } else if (payload === "REFRESH") {
        this.page = 1;
        window.scrollTo(0, 0);
      } else {
        this.page = 1;
      }
      axios
        .get(
          `${this.domain}/v1/pos/account/data?page=${this.page}&per_page=10&q=${this.query}`,
          {
            headers: {
              Authorization: this.token,
              "Content-Type": "application/json",
            },
          }
        )
        .then((response) => {
          if (response.data.data.length > 0) {
            if (this.page > 1) {
              window.scrollTo(0, 0);
            }
            this.memberPOSList = response.data.data;
          } else if (payload === "NEXT") {
            this.page = this.page - 1;
          } else if (response.data.data.length === 0 && payload === "") {
            this.memberPOSList = response.data.data;
          }
        })
        .catch((e) => {
          console.log("error :", e);
          Swal.fire({
            icon: "error",
            title: "Gagal mendapatkan list data member POS",
            showConfirmButton: false,
            timer: 2000,
          });
        });
    },
    bulkInsert(type) {
      if (this.fileData !== "" || this.fileDataUsername !== "") {
        var form = new FormData();
        var path = "";
        if (type === "member") {
          path = "/v1/import/member/pos";
          form.append("pos_account_file", this.fileData);
        } else if (type === "username") {
          path = "/v1/import/pos/username";
          form.append("pos_username_file", this.fileDataUsername);
        }

        axios
          .post(`${this.domain}${path}`, form, {
            headers: {
              Authorization: this.token,
              "Content-Type": "application/json",
            },
          })
          .then((resp) => {
            if (resp.status === 200) {
              this.responseMessage("success", "Data berhasil diupload");
              if (type === "member") {
                this.fileName = "";
                this.fileData = "";
                this.showFormCreate = false;
              } else if (type === "username") {
                this.fileUsername = "";
                this.fileDataUsername = "";
                this.showFormUsernameCreate = false;
              }
            }
            this.paginateData("");
          })
          .catch((err) => {
            this.responseMessage("error", err.response.data.message.id);
          });
      } else {
        this.responseMessage(
          "error",
          "Silahkan pilih berkas yang akan di upload"
        );
      }
    },
    toDetailPage(ID) {
      this.$router.push("/management/member-pos/detail/" + ID);
    },
    toEditPage(ID) {
      this.$router.push("/management/member-pos/edit/" + ID);
    },
    exportTemplate(payload) {
      var memberPOS = XLSX.utils.json_to_sheet(this.templateMemberPOS);
      var usernamePOS = XLSX.utils.json_to_sheet(this.templateUsernamePOS);
      var wb = XLSX.utils.book_new();
      if (payload === "template_member_pos") {
        XLSX.utils.book_append_sheet(wb, memberPOS, "Sheet1");
      } else if (payload === "template_username_pos") {
        XLSX.utils.book_append_sheet(wb, usernamePOS, "Sheet1");
      }

      XLSX.writeFile(wb, payload + ".xlsx");
    },
  },
};
</script>

<style scoped>
@import url("./MemberPOS.css");
</style>
